import { Button, IconButton, Menu, MenuItem } from "@mui/material";
import { IconPack } from "Explore/Config/Icons";
import { useState } from "react";
import styles from "./SortFaculty.module.scss";
import useFilterAndPagination from "Hooks/useFilterAndPagination";
import { ParamsFilterKey } from "Config/filterSearchParams";
import useDeviceCheck from "Hooks/useDeviceCheck";

const MAP_SORT_LABELS = Object.freeze({
  DEFAULT: "Overall relevance",
  H_INDEX: "Recent Influence",
  PUBLICATIONS: "Active Contributors",
  // RISING_STARS: "Rising Stars",
});

const SORT_VALUES = [
  { label: MAP_SORT_LABELS.DEFAULT, value: null },
  { label: MAP_SORT_LABELS.H_INDEX, value: "h_index" },
  { label: MAP_SORT_LABELS.PUBLICATIONS, value: "publication_count" },
  // { label: MAP_SORT_LABELS.RISING_STARS, value: "h_index" },
];

const SortEntity = () => {
  const { isTablet } = useDeviceCheck();
  const { updateSearchParams } = useFilterAndPagination();
  const [selectedSort, setSelectedSort] = useState(MAP_SORT_LABELS.DEFAULT);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onSelectSort = ({ label, value }) => {
    setSelectedSort(label);
    const newFilter = { [ParamsFilterKey.ORDER_BY]: value };
    if (label === MAP_SORT_LABELS.H_INDEX) {
      newFilter[ParamsFilterKey.KEYWORD_TIME_FILTER] = "recent";
    } else if (label === MAP_SORT_LABELS.PUBLICATIONS) {
      newFilter[ParamsFilterKey.KEYWORD_TIME_FILTER] = "recent";
    } else if (label === MAP_SORT_LABELS.RISING_STARS) {
      newFilter[ParamsFilterKey.SENIORITIES] = [0];
      newFilter[ParamsFilterKey.KEYWORD_TIME_FILTER] = "recent";
    }
    updateSearchParams(newFilter);

    handleClose();
  };

  return (
    <>
      {isTablet ? (
        <IconButton
          className={styles["sort-faculty"]}
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          {IconPack.sort}
        </IconButton>
      ) : (
        <Button
          className={styles["sort-faculty"]}
          onClick={(e) => setAnchorEl(e.currentTarget)}
          startIcon={IconPack.sort}
        >
          Sort
        </Button>
      )}
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
        {SORT_VALUES.map(({ label, value }, i) => (
          <MenuItem
            key={i}
            selected={selectedSort === label}
            onClick={() => {
              onSelectSort({ label, value });
            }}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SortEntity;
